// extracted by mini-css-extract-plugin
export default {"personCard":"your-career-people_personCard__uwl6c","personCardIcon":"your-career-people_personCardIcon__LcoYd","personCardContent":"your-career-people_personCardContent__7wFLR"};